import { jsPDF } from 'jspdf'

/** Hoja original: 400 × 600 px (≈ 188 × 282 mm al imprimir) */
export const QR_PDF_PAGE_WIDTH_PX = 400
export const QR_PDF_PAGE_HEIGHT_PX = 600

/**
 * En jsPDF con unit 'px', 1 unidad px ≈ 25.4/54 mm físicos.
 * 50 mm = 5 cm exactos sobre la hoja original.
 */
export const QR_PDF_QR_SIZE_PX = (50 * 54) / 25.4
export const QR_PDF_QR_X_PX = (QR_PDF_PAGE_WIDTH_PX - QR_PDF_QR_SIZE_PX) / 2
export const QR_PDF_QR_Y_PX = 200
export const QR_PDF_TEXT_X_PX = QR_PDF_PAGE_WIDTH_PX / 2
export const QR_PDF_FONT_SIZE = 12
/** Espacio entre el borde inferior del QR y el texto */
export const QR_PDF_TEXT_GAP_PX = 8
export const QR_PDF_TEXT_Y_PX =
  QR_PDF_QR_Y_PX + QR_PDF_QR_SIZE_PX + QR_PDF_TEXT_GAP_PX + QR_PDF_FONT_SIZE

/** Canvas oculto: 200 px, sin cambios respecto al original */
export const QR_CANVAS_PX = 200
export const QR_PDF_JPEG_QUALITY = 0.85

export function createQrPdfDocument(): jsPDF {
  return new jsPDF({
    orientation: 'portrait',
    unit: 'px',
    format: [QR_PDF_PAGE_WIDTH_PX, QR_PDF_PAGE_HEIGHT_PX],
    compress: true,
  })
}

export function addQrPageToPdf(
  doc: jsPDF,
  qrImgData: string,
  idQr: string,
  isFirstPage: boolean
): void {
  if (!isFirstPage) {
    doc.addPage([QR_PDF_PAGE_WIDTH_PX, QR_PDF_PAGE_HEIGHT_PX], 'portrait')
  }

  doc.addImage(
    qrImgData,
    'JPEG',
    QR_PDF_QR_X_PX,
    QR_PDF_QR_Y_PX,
    QR_PDF_QR_SIZE_PX,
    QR_PDF_QR_SIZE_PX
  )

  doc.setFont('helvetica', 'normal')
  doc.setFontSize(QR_PDF_FONT_SIZE)
  doc.text(`QR: ${idQr}`, QR_PDF_TEXT_X_PX, QR_PDF_TEXT_Y_PX, { align: 'center' })
}

/** Espera a que React pinte los canvas ocultos antes de leerlos */
export function waitForQrCanvasRender(): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => resolve())
    })
  })
}
